import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useActivePlaylist, useSettings } from "../providers/PlaylistProvider";
import { formatDateTime } from "./useDateFormatter";
import { deviceLocale } from "../helpers/localise";
import { TimeZone } from "../../types";

const userDefaultTimeZone = (Intl.DateTimeFormat().resolvedOptions().timeZone ??
  "UTC") as TimeZone;

export const useCurrentDate = () => {
  const { t } = useTranslation("dateFormats");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const timeZone = useSettings()?.deviceTimeZone ?? userDefaultTimeZone;
  const playlist = useActivePlaylist();

  useEffect(() => {
    const updateDate = () => {
      const locale = playlist.locale ?? deviceLocale;
      const newDate = new Date();
      setDate(
        formatDateTime(newDate, t("currentDateFormat"), locale, timeZone),
      );
      setTime(
        formatDateTime(newDate, t("currentTimeFormat"), locale, timeZone),
      );
    };

    if (date.length === 0) {
      updateDate();
    }

    const timeout = setInterval(updateDate, 10000);
    return () => clearInterval(timeout);
  }, [timeZone, date, t, playlist.locale]);

  return { date, time };
};
